import React from "react";
import { Link } from "react-router-dom";
import { BsFolderSymlinkFill } from "react-icons/bs";
import { SlOptionsVertical } from "react-icons/sl";
import { Dropdown } from "flowbite-react";
const FolderCard = ({
  title,
  folderId,
  fileCount,
  fileSize,
  setOpenModal,
  setFolderModalFor,
  setSelectedFolder,
}) => {
  
  return (
    <div className="bg-white p-4 rounded-md border border-gray-200 w-full h-full">
      <div className="flex items-center justify-between h-full">
        <div className="flex flex-col justify-between items-center space-x-2 h-full">
          <button>
            <div className="h-1/2 flex flex-row items-start mb-4">
              <Link to={`/dashboard/folder/${title}/${folderId}`}>
                <BsFolderSymlinkFill size={60} color="#F5D14B" />
              </Link>
            </div>
            <div className="flex flex-col items-start">
              <h3 className="font-bold text-lg">{title}</h3>
              <p>{String(fileCount)} Files</p>
            </div>
          </button>
        </div>
        <div className="flex flex-col justify-between h-full items-center">
          <Dropdown
            dismissOnClick={false}
            placement="left-end"
            renderTrigger={() => (
              <button className="pt-4 pl-8">
                <SlOptionsVertical size={20} />
              </button>
            )}
          >
            <Dropdown.Item>
              <Link to={`/dashboard/folder/${title}/${folderId}`}>Open</Link>
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setFolderModalFor("rename");
                setSelectedFolder({ folderId, title });
                setOpenModal("popup");
              }}
            >
              Rename
            </Dropdown.Item>
          </Dropdown>
          <p>{fileSize}</p>
        </div>
      </div>
    </div>
  );
};

export default FolderCard;
